import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_BASE = `https://api.dilanaslan.com/api/contact`;

// Veriyi çek
export const fetchContact = createAsyncThunk(
  "contact/fetchContact",
  async () => {
    const res = await axios.get(API_BASE);
    return res.data;
  }
);

// Veriyi güncelle
export const updateContact = createAsyncThunk(
  "about/updateAbout",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.put(API_BASE, payload);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const contactSlice = createSlice({
  name: "contact",
  initialState: {
    data: null,
    loading: false,
    error: null,
    success: false,
  },
  reducers: {
    clearSuccess: (state) => {
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchContact.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchContact.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchContact.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(updateContact.fulfilled, (state, action) => {
        state.data = action.payload;
        state.success = true;
      })
      .addCase(updateContact.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const { clearSuccess } = contactSlice.actions;
export default contactSlice.reducer;
